import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import {
  NgbAccordionConfig,
  NgbModal,
  ModalDismissReasons,
  NgbNavChangeEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { GenerateAiContentComponent } from "src/app/Modals/generate-ai-content/generate-ai-content.component";
import { CrudService } from "src/app/Services/crud.service";
import { FormStateService } from "src/app/Services/form.service";
import { LoadingService } from "src/app/Services/loading.service";
import { LogedInUserService } from "src/app/Services/loged-in-user.service";
import { ThemeOptions } from "src/app/theme-options";

@Component({
  selector: "app-dynamic-faq-form",
  templateUrl: "./dynamic-faq-form.component.html",
  standalone: false,
  styles: [``],
})
export class DynamicFaqFormComponent implements OnInit {
  @Input() faq;
  @Input() screen;
  @Input() project;
  @Input() projectVersion;
  @Input() selectedEnv;
  @Input() id;
  // @Input() roles;
  closeResult;
  @Input("roles") roles;

  @Output() onLanguageChange = new EventEmitter<any>();
  @Output() formSubmitted: EventEmitter<void> = new EventEmitter<void>();
  @Input() selectedLanguage;
  @Input() translatedValue: {
    id: number;
    question: string;
    answer: string;
  } | null;
  form: UntypedFormGroup;
  currentFAQ;
  submitted = false;
  answerError = false;
  languageList = [];
  disableSave = false;
  publishToProd = false;
  publishToQA = false;
  addFAQ = false;
  versionList = [];
  workflowList = [];
  ugClassList = [];
  // roles = [];
  loadingSub;
  faqId: string = "";
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "15rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "yes",
    toolbarHiddenButtons: [["insertImage", "insertVideo"]],
  };

  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private logedInUserService: LogedInUserService,
    private route: ActivatedRoute,
    config: NgbAccordionConfig,
    private router: Router,
    public globals: ThemeOptions,
    private modalService: NgbModal,
    private formStateService: FormStateService,
    private loadingService: LoadingService
  ) {
    this.getLanguages();
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }
  isLoading = false;
  ngOnInit() {
    // console.log("roles", this.roles);
    this.faq == "new" ? (this.addFAQ = true) : (this.addFAQ = false);

    this.getAppRoles();
    this.getWorkflowList = this.getWorkflowList.bind(this);
    this.getWorkflowList();
    this.showSelectedLangaugeFAQ.bind(this);
    this.form = this.formBuilder.group({
      question: ["", Validators.required, ""],
      answer: ["", Validators.required, ""],
      projectVersion: [],
      languageId: [],
      screenManagementId: [],
      screenType: ["screenSpecific", Validators.required, ""],
      displayOrder: ["", ""],
      projectManagementId: [],
      id: [],
      roles: [""],
    });
    this.form.valueChanges.subscribe(() => {
      if (this.form.dirty) {
        this.formStateService.setFormDirty();
      }
    });
    this.getScreenDefaultOrder();
    this.currentFAQ = Object.assign({}, this.addFAQ == false ? this.faq : null);
    this.form.patchValue(this.currentFAQ);
    if (!this.addFAQ) {
      this.getlastPublishStage(this.currentFAQ.faqId);
    }
    this.loadingSub = this.loadingService.loading$.subscribe((val) => {
      this.isLoading = val;
    });
  }
  /*  ngOnChanges(changes: SimpleChanges) {
    if (changes["translatedValue"] && this.translatedValue) {
      this.form.patchValue({
        question: this.translatedValue.question,
        answer: this.translatedValue.answer,
      });
    }
    if (changes["selectedLanguage"]) {
      const newLanguage = changes["selectedLanguage"].currentValue;
      console.log("Language changed to:", newLanguage);
      if (this.faq.languageId == newLanguage) {
        return;
      } else {
        console.log("faq here", this.faq);
        if (this.faq && this.faq.supportedLanguages) {
          this.form.patchValue({
            answer: this.faq.map((item) => {
              const matchedLang = item.supportedLanguages?.find(
                (lang) => lang.id === this.selectedLanguage
              );

              return matchedLang?.answer;
            }),
          });
        }
      }
    }
  } */
  getAppRoles() {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        // console.log("roles response", response);
        if (response && response.length) {
          self.roles = response;
        } else {
          self.roles = [];
        }
      },
      `appRoles?filter[where][version]=${self.projectVersion}&filter[where][projectManagementId]=${self.project.id}`
    );
  }
  getGenericDefaultOrder() {
    let self = this;
    let query = `filter[where][publishStage]=${self.selectedEnv}&filter[where][projectVersion]=${self.projectVersion}&filter[where][screenType]=generic`;

    self.crudService.get(
      null,
      function (response) {
        if (
          response &&
          response.length &&
          self.form.value.screenType == "generic" &&
          !self.currentFAQ.id
        ) {
          self.form.patchValue({ displayOrder: response.length + 1 });
        }
      },
      "currentFaqDetails?" + query
    );
  }

  getScreenDefaultOrder() {
    let self = this;
    let query = `filter[where][publishStage]=${self.selectedEnv}&filter[where][projectVersion]=${self.projectVersion}&filter[where][screenManagementId]=${self.screen.id}`;

    self.crudService.get(
      null,
      function (response) {
        if (
          response &&
          response.length &&
          self.form.value.screenType != "generic" &&
          !self.currentFAQ.id
        ) {
          self.form.patchValue({ displayOrder: response.length + 1 });
        }
      },
      "currentFaqDetails?" + query
    );
  }

  getWorkflowList() {
    let self = this;
    let query = `screenManagementId=${self.screen.id}&publishStage=${self.selectedEnv}&projectVersion=${self.projectVersion}&projectManagementId=${this.project.id}`;

    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.workflowList = response;
        } else {
          self.workflowList = [];
        }
        self.getUGCLassList();
      },
      "workflows/getWorkflowsForWebAndPlugin?" + query
    );
  }

  getUGCLassList() {
    let self = this;
    let query = `filter[where][projectManagementId]=${self.project.id}&filter[where][projectVersion]=${self.projectVersion}`;

    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.ugClassList = response;
        } else {
          self.ugClassList = [];
        }
        self.injectCustomWorkflowDropdown();
      },
      "userGuideClasses?" + query
    );
  }

  injectCustomWorkflowDropdown() {
    setTimeout(() => {
      const toolbarElements = document.querySelectorAll(
        ".angular-editor-toolbar"
      );
      toolbarElements.forEach((toolbar, index) => {
        if (!toolbar) return;

        // Check if the dropdown is already present by ID
        if (toolbar.querySelector(`#workflow-faq-editor`)) return;
        if (toolbar != null) {
          var customDiv = document.createElement("div");
          customDiv.id = `workflow-dropdown-${index}`;
          customDiv.style.display = "flex";
          customDiv.style.columnGap = "5px";
          customDiv.style.height = "35px";
          var dropdown = document.createElement("div");
          dropdown.classList.add("angular-editor-toolbar-set");
          dropdown.innerHTML =
            '<label class="block-label" tabindex="-1" for="workflow-faq-editor"></label>' +
            '<select title="Workflow" style="height: 85%;" id="workflow-faq-editor" class="select-custom-style">' +
            '<option value="">Insert Workflow</option>' +
            this.workflowList
              .map(
                (option) =>
                  `<option value="${option.name}">${option.name}</option>`
              )
              .join("") +
            "</select>";
          var dropdown2 = document.createElement("div");
          dropdown2.id = `style-dropdown-${index}`;
          dropdown2.classList.add("angular-editor-toolbar-set");
          dropdown2.innerHTML =
            '<label class="block-label" tabindex="-1" for="class-faq-editor"></label>' +
            '<select title="customclass" style="height: 85%;" id="class-faq-editor" class="select-custom-style">' +
            '<option value="">Apply Class</option>' +
            '<option value="clear-class">Clear Class</option>' +
            '<option value="code">Code</option>' +
            '<option value="navigation">Navigation</option>' +
            '<option value="icon">Icon</option>' +
            '<option value="screenshot">Screenshot</option>' +
            '<option value="notes">Notes/Tips</option>' +
            this.ugClassList
              .map(
                (option) =>
                  `<option value="${option.className}">${option.name}</option>`
              )
              .join("") +
            "</select>";
          if (
            toolbar.querySelector(`#workflow-dropdown-${index}`) == null &&
            toolbar.querySelector("#workflow-faq-editor") == null
          ) {
            customDiv.append(dropdown);
          }

          if (
            (toolbar.querySelector(`#style-dropdown-${index}`) == null &&
              toolbar.querySelector("#class-faq-editor")) == null
          ) {
            customDiv.append(dropdown2);
          }
        }

        toolbar.append(customDiv);

        var selected = document.getElementById(
          "workflow-faq-editor"
        ) as HTMLSelectElement;
        selected.addEventListener("change", () => {
          this.handleWorkflowSelection(selected.value);
          selected.value = "";
        });

        var selected2 = document.getElementById(
          "class-faq-editor"
        ) as HTMLSelectElement;
        selected2.addEventListener("change", () => {
          this.handleClassSelection(selected2.value);
          selected2.value = "";
        });
      });
    }, 200);
  }

  handleClassSelection(selectedValue: string) {
    const selection = window.getSelection();

    if (!selection.isCollapsed) {
      const range = selection.getRangeAt(0);
      let ancestorElement = null;
      let node = range.commonAncestorContainer;

      // Find the nearest ancestor element
      while (node) {
        if (node.nodeType === 1) {
          ancestorElement = node as Element;
          break;
        }
        node = node.parentNode;
      }

      if (selectedValue === "clear-class") {
        // Remove class from the selected element
        if (ancestorElement) {
          ancestorElement.removeAttribute("class");
          setTimeout(() => {
            this.updateFormContent();
          }, 100);
        }
      } else {
        // Check if the selected content includes an image
        if (ancestorElement && ancestorElement.nodeName === "IMG") {
          // Apply class directly to the image
          ancestorElement.setAttribute("class", selectedValue);
        } else {
          // Apply class to the selected text or elements that are not images
          if (range.startContainer.parentNode.nodeName !== "IMG") {
            const newNode = document.createElement("span");
            newNode.setAttribute("class", selectedValue);
            newNode.appendChild(range.extractContents()); // Retain the original content inside the new span

            // Insert the new node in place of the original selection
            range.insertNode(newNode);

            // Clear the selection to avoid duplicating spans
            selection.removeAllRanges();
          }
        }

        setTimeout(() => {
          this.updateFormContent();
        }, 100);
      }
    }
  }

  // Helper method to update form content
  updateFormContent() {
    var editorId = document.querySelector(".angular-editor-textarea");
    this.form.setValue({
      question: this.form.value.question,
      answer: editorId.innerHTML,
      projectVersion: this.form.value.projectVersion,
      languageId: this.form.value.languageId,
      screenManagementId: this.screen.id,
      projectManagementId: this.project.id,
      screenType: this.form.value.screenType,
      displayOrder: this.form.value.displayOrder,
      id: this.form.value.id,
    });
    this.form.markAsDirty();
  }

  handleWorkflowSelection(selectedValue: string) {
    const selection = window.getSelection();

    if (!selection.isCollapsed) {
      const range = selection.getRangeAt(0);
      const selectedText = selection.toString();

      let ancestorSpan = null;
      let node = range.commonAncestorContainer;
      while (node) {
        if (
          node.nodeType === 1 &&
          (node as Element).nodeName === "SPAN" &&
          (node as Element).hasAttribute("workflowtrigger")
        ) {
          ancestorSpan = node as Element;
          break;
        }
        node = node.parentNode;
      }
      if (ancestorSpan && ancestorSpan?.textContent?.trim() === selectedText) {
        ancestorSpan.setAttribute("workflowtrigger", selectedValue);
        setTimeout(() => {
          var editorId = document.querySelector(".angular-editor-textarea");
          this.form.setValue({
            question: this.form.value.question,
            answer: editorId.innerHTML,
            projectVersion: this.form.value.projectVersion,
            languageId: this.form.value.languageId,
            screenManagementId: this.screen.id,
            projectManagementId: this.project.id,
            screenType: this.form.value.screenType,
            displayOrder: this.form.value.displayOrder,
            id: this.form.value.id,
          });
          this.form.markAsDirty();
        }, 100);
      } else {
        const newNode = document.createElement("span");
        newNode.setAttribute("workflowtrigger", selectedValue);
        newNode.textContent = selectedText;
        newNode.style.color = "blue";
        newNode.style.cursor = "pointer";
        setTimeout(() => {
          var editorId = document.querySelector(".angular-editor-textarea");
          this.form.setValue({
            question: this.form.value.question,
            answer: editorId.innerHTML,
            projectVersion: this.form.value.projectVersion,
            languageId: this.form.value.languageId,
            screenManagementId: this.screen.id,
            projectManagementId: this.project.id,
            screenType: this.form.value.screenType,
            displayOrder: this.form.value.displayOrder,
            id: this.form.value.id,
          });
          this.form.markAsDirty();
        }, 100);
        range.deleteContents();
        range.insertNode(newNode);
      }
    }

    selection.removeAllRanges();
  }

  getlastPublishStage(faqId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        if (response.publishStage == "dev") {
          self.publishToQA = true;
          self.publishToProd = false;
        } else if (response.publishStage == "qa") {
          self.publishToQA = false;
          self.publishToProd = true;
        } else if (response.publishStage == "prod") {
          self.publishToProd = false;
        }
      },
      `currentFaqDetails/findOne?filter[where][faqId]=${faqId}`
    );
  }

  get f() {
    return this.form.controls;
  }
  getLanguages() {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.languageList = response;
      },
      "languages"
    );
  }

  onSubmit() {
    this.submitted = true;
    var self = this;
    if (!this.form.value.answer) {
      this.answerError = true;
      return;
    } else {
      this.answerError = false;
    }
    if (this.form.invalid) return;

    var payload;

    if (this.addFAQ) {
      var languageId = this.project.primaryLanguage;
      var screenId = this.screen.id;
      var faqpayload = {
        languageId: this.project.primaryLanguage,
        screenManagementId: this.screen.id,
        projectManagementId: this.project.id,
        displayOrder: this.form.value["displayOrder"],
      };

      this.crudService.post(
        faqpayload,
        (response) => {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            this.faqId = response.id;
            payload = {
              ...self.form.value,
              publishStage: "dev",
              languageId: languageId,
              screenManagementId: screenId,
              projectManagementId: this.project.id,
              faqId: response.id,
              projectVersion: this.projectVersion,
              roles: this.form.value["roles"] ? this.form.value["roles"] : [],
            };

            self.crudService.update(
              payload,
              function (response) {
                if (
                  response.error &&
                  response.error.error &&
                  response.error.error.message
                ) {
                  self.toastr.error(
                    response.error.error.message,
                    "Invalid Operation"
                  );
                  self.form.markAsPristine();
                  self.formStateService.clearFormDirty();
                } else {
                  self.toastr.success(
                    "FAQ has been created successfully.",
                    "Success"
                  );
                  self.formSubmitted.emit();
                  self.currentFAQ = response;
                  self.form.markAsPristine();
                  self.formStateService.clearFormDirty();
                  self.getlastPublishStage(self.currentFAQ.faqId);
                }
              },
              "currentFaqDetails/addFaqToTable"
            );
          }
        },
        "faqs"
      );
    } else {
      payload = {
        ...this.form.value,
        id: undefined,
        publishStage: "dev",
        faqId: this.currentFAQ.faqId,
        projectManagementId: this.project.id,
        roles: this.form.value["roles"] ? this.form.value["roles"] : [],
        displayOrder: this.form.value["displayOrder"],
      };

      this.crudService.update(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
            self.form.markAsPristine();
            self.formStateService.clearFormDirty();
          } else {
            self.currentFAQ = response;
            self.toastr.success(
              "FAQ has been created successfully.",
              "Success"
            );
            self.formSubmitted.emit();
            self.form.markAsPristine();
            self.formStateService.clearFormDirty();
            self.getlastPublishStage(self.currentFAQ.faqId);
          }
        },
        "currentFaqDetails/addFaqToTable"
      );
    }
    this.submitted = false;
  }

  onReset() {
    this.submitted = false;
    if (this.addFAQ) {
      this.form.reset();
      this.formStateService.clearFormDirty();
    } else {
      this.form.patchValue(this.currentFAQ);
      this.form.markAsPristine();
      this.formStateService.clearFormDirty();
    }
  }

  onClickOfPublish(publishStage: string) {
    var self = this;
    if (this.form.invalid) return;
    var payload = {
      ...this.form.value,
      id: undefined,
      publishStage: publishStage,
      faqId: this.currentFAQ.faqId,
      projectManagementId: this.project.id,
    };
    this.crudService.post(
      payload,
      function (response) {
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.toastr.error(response.error.error.message, "Invalid Operation");
          self.form.markAsPristine();
          self.formStateService.clearFormDirty();
        } else {
          self.toastr.success(
            "FAQ has been published successfully.",
            "Success"
          );
          self.formSubmitted.emit();
          self.form.markAsPristine();
          self.formStateService.clearFormDirty();
        }
      },
      "currentFaqDetails"
    );

    self.getlastPublishStage(this.currentFAQ.faqId);
  }

  showSelectedLangaugeFAQ(languageId) {
    let self = this;

    if (languageId === self.project.primaryLanguage) {
      if (this.addFAQ) {
        this.currentFAQ = Object.assign({}, this.currentFAQ);
      } else {
        this.currentFAQ = Object.assign({}, this.faq);
      }
      this.form.patchValue(this.currentFAQ);
      self.onLanguageChange.emit({
        id: self.currentFAQ.id,
        name: self.getLanguageName(languageId),
      });
    } else if (languageId !== self.project.primaryLanguage) {
      self.crudService.get(
        null,
        function (response) {
          var isFAQExistForSelectedLangauge =
            response &&
            response.length &&
            response.find(function (val) {
              return val.languageId === languageId;
            });
          if (isFAQExistForSelectedLangauge) {
            self.currentFAQ = isFAQExistForSelectedLangauge;
            self.form.patchValue(isFAQExistForSelectedLangauge);
            self.onLanguageChange.emit({
              id: self.currentFAQ.parentId,
              name: self.getLanguageName(languageId),
            });
          } else {
            let newobj = { ...self.currentFAQ, parentId: self.currentFAQ.id };
            newobj.languageId = languageId;
            delete newobj.id;
            self.crudService.post(
              newobj,
              function (response) {
                if (
                  response.error &&
                  response.error.error &&
                  response.error.error.message
                ) {
                  self.toastr.error(
                    response.error.error.message,
                    "Invalid Operation"
                  );
                } else {
                  self.toastr.success(
                    "FAQ has been created for new language successfully.",
                    "Success"
                  );
                  self.formSubmitted.emit();
                  self.currentFAQ = response;
                  self.form.patchValue(response);
                  self.onLanguageChange.emit({
                    id: self.currentFAQ.parentId,
                    name: self.getLanguageName(languageId),
                  });
                }
              },
              "currentFaqDetails"
            );
          }
        },
        'currentFaqDetails?filter={"where":{"parentId":"' +
          self.currentFAQ.id +
          '"}}'
      );
    }
  }

  getLanguageName(languageId) {
    if (this.languageList.length) {
      var langauge = this.languageList.find(function (val) {
        return val.id === languageId;
      });
      if (langauge) {
        return langauge.name;
      } else {
        return "English";
      }
    }
  }

  navigateProjectScreen() {
    this.router.navigate(["/page/project-management", this.project.id]);
  }

  open(content) {
    this.modalService.open(content);
  }

  getNewLanguage() {
    var self = this;
    var newlan = [];
    self.languageList.forEach(function (lan) {
      var isExist = self.project.supportedLanguage.find(function (sl) {
        return sl.id === lan.id;
      });
      if (!isExist && lan.id != self.project.primaryLanguage) {
        newlan.push(lan);
      }
    });
    return newlan;
  }

  saveNewSelectedLanguage(newLanguageList) {
    var self = this;
    if (newLanguageList.selectedOptions.selected.length) {
      newLanguageList.selectedOptions.selected.forEach((selectedNewLan) => {
        var isExist = self.languageList.find(function (sl) {
          return sl.name == selectedNewLan.getLabel()?.trim();
        });
        if (isExist) {
          self.project.supportedLanguage.push(isExist);
        }
      });

      self.crudService.update(
        self.project,
        function (response) {
          if (response) {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              self.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              self.project = response;
              self.toastr.success(
                "New language added successfully to the project.",
                "Success"
              );
            }
          }
        },
        "projectManagements"
      );
    }
    self.modalService.dismissAll();
  }

  reWriteAnswer() {
    var editorId = document.querySelector(".angular-editor-textarea");
    const plainText = editorId.innerHTML.replace(/<[^>]*>/g, "");
    var modalref = this.modalService.open(GenerateAiContentComponent, {
      backdrop: "static",
      windowClass: "top-modal custom-width-modal",
    });

    modalref.componentInstance.title = "FAQs";
    modalref.componentInstance.prompt = `I have an existing FAQ that already has an answer.I need the answer rewritten in a simpler and clearer way.
    Here is the current answer:${plainText} Context for rewriting:
    Project Name: ${this.project.name}
    Project Description: ${this.project["description"]}
    Screen Name: ${this.project.name}
    Screen Description: ${
      this.screen["description"] != undefined &&
      this.screen["description"] != null &&
      this.screen["description"]?.trim() != ""
        ? this.screen["description"]
        : ""
    } Please rewrite the answer in plain, user-friendly language while keeping the context above in mind. 
     Please rewrite the answer to be:Easy to understand,Accurate to the context`;
    modalref.componentInstance.currentScreen = this.screen;
    modalref.componentInstance.selectedVersion = this.projectVersion;
    modalref.componentInstance.currentProject = this.screen;
    modalref.componentInstance.projectId = this.project.id;
    modalref.componentInstance.screenId = this.screen.id;
    modalref.componentInstance.toReWrite = true;
    modalref.componentInstance.id = this.f.id.value;
    modalref.componentInstance.contentResponseforFAQ.subscribe((response) => {
      if (response) {
        this.loadingService.hide();
        editorId.innerHTML = response;
        this.form.get("answer")?.markAsDirty();
      }
    });
    modalref.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return "by pressing ESC";
      case ModalDismissReasons.BACKDROP_CLICK:
        return "by clicking on a backdrop";
      default:
        return `with: ${reason}`;
    }
  }
}
/*    .btn:disabled {
        background-color: #032d55 !important;
      }

      .badge-secondary {
        background-color: #717171 !important;
      } */
